import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import {
  Grid,
} from "@mui/material";
import RedirectInfo from "../../containers/RedirectInfo";
import { mainBackgroundStyles } from "../../styles/common";

function Redirect() {
  const { id } = useParams();

  return (
    <>
      <Helmet>
        <title>{id ? `Update redirect: ${id}` : "Create redirect"}</title>
      </Helmet>
      <Grid
        container
        direction="column"
        sx={mainBackgroundStyles}
      >
        <Grid>
          <RedirectInfo />
        </Grid>
      </Grid>
    </>
  );
}

export default Redirect;
